import React, { SFC } from 'react';

import { Icon, Tooltip } from 'antd';
import styled from 'styled-components';

interface SubformPanelHeaderProps {
    text: string;
    showCheckMark: boolean;
}

const SubformPanelHeaderWrapper = styled.div`
    font-weight: 500;
`;

const RightIcon = styled(Icon)`
    float: right;
    font-size: 20px;
`;

export const SubformPanelHeader: SFC<SubformPanelHeaderProps> = ({ text, showCheckMark }) => (
    <SubformPanelHeaderWrapper>
        {text}
        {showCheckMark && (
            <Tooltip title="El formato ha sido guardado">
                <RightIcon type="check-circle" theme="twoTone" />
            </Tooltip>
        )}
    </SubformPanelHeaderWrapper>
);
